import { Stack } from "@mui/material";
import { RecommendedListHeader } from "./RecommendedListHeader";
import { TableColumnType } from "../../types/genereal";
import { RecommendedAccount } from "../../types/apiTypes";
import { useStateWithSearchParams } from "../../hooks";
import { QUERY_SEPARATOR } from "../../constant";
import { TierType } from "../../types/enums";
import { RecommendedListBlock } from "./RecommendedListBlock";

const columns: TableColumnType[] = [
  {
    key: "tier",
    minWidth: "220px",
    maxWidth: "220px",
    label: "Tier",
    textAlign: "left",
  },
  {
    key: "name",
    minWidth: "150px",
    maxWidth: "100%",
    label: "Account  Name",
    textAlign: "left",
  },
  {
    key: "industry",
    minWidth: "120px",
    maxWidth: "200px",
    label: "Industry",
    textAlign: "left",
  },
  {
    key: "region",
    minWidth: "120px",
    maxWidth: "160px",
    label: "Region",
    textAlign: "left",
  },
  {
    key: "size",
    minWidth: "120px",
    maxWidth: "160px",
    label: "Size",
    textAlign: "left",
  },
  {
    key: "revenue",
    minWidth: "100px",
    maxWidth: "100px",
    label: "Revenue",
    textAlign: "left",
  },

  {
    key: "menu",
    minWidth: "48px",
    maxWidth: "48px",
    label: "",
    textAlign: "center",
    padding: "0 5px",
  },
  {
    key: "checkbox",
    minWidth: "48px",
    maxWidth: "48px",
    label: "",
    textAlign: "center",
    padding: "0",
  },
];

type SearchParams = {
  selected?: string;
};

type Props = {
  recommendedAccounts: Record<TierType, RecommendedAccount[]>;
};

export const RecommendedTableBlock = ({ recommendedAccounts }: Props) => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      selected: undefined,
    },
  );

  const tiers = Object.entries(recommendedAccounts);

  const selected = searchDict.selected?.split(QUERY_SEPARATOR) || [];
  const allIds = tiers.reduce(
    (acc, [_, items]) => [...acc, ...items.map(({ id }) => id)],
    [] as string[],
  );

  const isAllSelected =
    selected.length === allIds.length && selected.length > 0;

  const selectAllHandler = () => {
    setSearchValue(
      "selected",
      isAllSelected ? undefined : allIds.join(QUERY_SEPARATOR),
    );
  };

  const isDemo = allIds.length === 0;

  return (
    <Stack>
      <RecommendedListHeader
        columns={columns}
        isSelectedAll={isAllSelected}
        selectAllHandler={selectAllHandler}
        isDisabled={isDemo}
      />

      {isDemo ? (
        <RecommendedListBlock
          recommendedAccounts={[]}
          columns={columns}
          tier={TierType.high}
          isDemo={isDemo}
        />
      ) : (
        tiers.map(([tier, recommendedAccounts]) => (
          <RecommendedListBlock
            key={tier}
            recommendedAccounts={recommendedAccounts}
            columns={columns}
            tier={tier as TierType}
            isDemo={isDemo}
          />
        ))
      )}
    </Stack>
  );
};
